const C = require("../constants");

const ticketHistoryDialog = (data) => {
    return {
        type: C.TICKET_HISTORY_DIALOG,
        data
    }
};

export {ticketHistoryDialog};


// WEBPACK FOOTER //
// ./src/actions/TicketHistroyActions.js